import { ValidationError } from './exceptions';
import { ErrorType } from './types';

export class ValidationResult {
    constructor(public errorsPerFieldName: Record<string, ErrorType[]> = {}) {
        /**
         * errorsPerFieldName: object with the field name as key and the errors types as values.
         * Ex: {errors: {address: ['required']}}
         */
        this.errorsPerFieldName = errorsPerFieldName;
    }

    public pushErrors(fieldName: string, errors: ErrorType[]): this {
        if (!errors || errors.length === 0) {
            return this;
        }

        // If fieldName has no error for now, we simply insert it
        if (!(fieldName in this.errorsPerFieldName)) {
            this.errorsPerFieldName[fieldName] = errors;
            return this;
        }

        // Else, we merge errors by avoiding errors with same code.
        for (const error of errors) {
            if (
                this.errorsPerFieldName[fieldName].find((value) => value.code === error.code) ===
                undefined
            ) {
                this.errorsPerFieldName[fieldName].push(error);
            }
        }
        return this;
    }

    public mergeWith(validationErrors: ValidationResult): this {
        for (const fieldName in validationErrors.errorsPerFieldName) {
            if (fieldName in this.errorsPerFieldName) {
                this.errorsPerFieldName[fieldName] = [
                    ...this.errorsPerFieldName[fieldName],
                    ...validationErrors.errorsPerFieldName[fieldName],
                ];
            } else {
                this.errorsPerFieldName[fieldName] = validationErrors.errorsPerFieldName[fieldName];
            }
        }
        return this;
    }

    public hasSucceeded(): boolean {
        return Object.keys(this.errorsPerFieldName).length === 0;
    }

    public throwErrorIfFailed(): void {
        if (!this.hasSucceeded()) {
            throw new ValidationError(this.errorsPerFieldName);
        }
    }
}
